import React from 'react';
import Scroll from 'react-scroll';

import { IPropsScrollElement } from './models';
import './ScrollElement.scss';

const ScrollElement = (props: IPropsScrollElement) => (
  <>
    {props.name ? (
      <div className="scroll-element">
        <a
          {...props}
          id={props.name.replace('#', '')}
          ref={(el: HTMLAnchorElement | null) => {
            props.parentBindings.domNode = el;
          }}
          className="scroll-element__anchor"
        >
          {' '}
        </a>
        {props.children}
      </div>
    ) : (
      <>{props.children}</>
    )}
  </>
);

export default Scroll.ScrollElement(ScrollElement);
